import { createRouter, createWebHistory } from 'vue-router';
import { handleHotUpdate, routes } from 'vue-router/auto-routes';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to) => {
  // A saved mobile-web-app may retain an old local bot descriptor after a
  // gateway restart.  Re-provision from the authenticated same-origin fleet
  // before creating stores, so cards always use the current proxy routes.
  if (!to.meta?.allowAnonymous) {
    const fleetReady = await provisionFleetBots();
    if (!fleetReady) {
      return {
        path: '/login',
        query: { redirect: to.fullPath },
      };
    }
  }
  initBots();
  const botStore = useBotStore();
  if (!to.meta?.allowAnonymous && !botStore.hasBots) {
    // Forward to login if login is required
    return {
      path: '/login',
      query: { redirect: to.fullPath },
    };
  } else {
    return true;
  }
});

if (import.meta.hot) {
  handleHotUpdate(router);
}

export default router;
